'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ReactUtilsPropTypes from 'react-utils/CustomPropTypes';
import PropTypes from 'prop-types';
import UIButton from 'UIComponents/button/UIButton';
import BaseToolbar from 'DesignEditorsUI/components/shared/Toolbar';
import UndoRedo from 'DesignEditorsUI/components/shared/controls/UndoRedo';

const i18nKey = name => `DesignEditorsUI.shared.toolbars.${name}`;

class Toolbar extends PureComponent {
  /*
   * Render
   */
  renderLeftContent() {
    const {
      undoGlobalWidgetEdit,
      redoGlobalWidgetEdit,
      pastEditHistoryCount,
      futureEditHistoryCount,
      isPublishDisabled
    } = this.props;
    return /*#__PURE__*/_jsx(UndoRedo, {
      undo: undoGlobalWidgetEdit,
      redo: redoGlobalWidgetEdit,
      pastEditCount: pastEditHistoryCount,
      futureEditCount: futureEditHistoryCount,
      disabled: isPublishDisabled
    });
  }

  renderRightContent() {
    const {
      isPublishDisabled,
      publishGlobalWidget
    } = this.props;
    return /*#__PURE__*/_jsx(UIButton, {
      size: "extra-small",
      use: "primary",
      disabled: isPublishDisabled,
      onClick: publishGlobalWidget,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('buttons.publish')
      })
    });
  }

  render() {
    return /*#__PURE__*/_jsx(BaseToolbar, {
      leftContent: this.renderLeftContent(),
      rightContent: this.renderRightContent()
    });
  }

}

Toolbar.propTypes = {
  isPublishDisabled: PropTypes.bool.isRequired,
  publishGlobalWidget: PropTypes.func.isRequired,
  pastEditHistoryCount: ReactUtilsPropTypes.uint32.isRequired,
  futureEditHistoryCount: ReactUtilsPropTypes.uint32.isRequired,
  undoGlobalWidgetEdit: PropTypes.func.isRequired,
  redoGlobalWidgetEdit: PropTypes.func.isRequired
};
export default Toolbar;